import { render, staticRenderFns } from "./DeleteContentModal.vue?vue&type=template&id=32d65620&scoped=true&"
import script from "./DeleteContentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteContentModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteContentModal.vue?vue&type=style&index=0&id=32d65620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d65620",
  null
  
)

export default component.exports